import React, { useMemo } from "react"
import PropTypes from "prop-types"
import {
  getPasswordRuleStatuses,
  meetsPasswordRules,
} from "../../helpers/passwordRules"

/**
 * Live password checklist — shows each rule separately.
 * Empty: muted list. Typing: unmet rules in red, met in green.
 */
const PasswordRequirementsHint = ({ value = "" }) => {
  const text = String(value || "")
  const hasStarted = text.length > 0
  const allMet = meetsPasswordRules(text)
  const rules = useMemo(() => getPasswordRuleStatuses(text), [text])

  return (
    <ul
      className={[
        "password-rules",
        hasStarted && !allMet ? "password-rules--active" : "",
        allMet ? "password-rules--complete" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-live="polite"
    >
      {rules.map(rule => {
        const state = !hasStarted ? "idle" : rule.met ? "met" : "unmet"
        return (
          <li
            key={rule.id}
            className={`password-rules__item password-rules__item--${state}`}
          >
            <span className="password-rules__mark" aria-hidden="true">
              {state === "met" ? "✓" : state === "unmet" ? "•" : "○"}
            </span>
            <span className="password-rules__label">
              {hasStarted && !rule.met ? rule.hint : rule.label}
            </span>
          </li>
        )
      })}
    </ul>
  )
}

PasswordRequirementsHint.propTypes = {
  value: PropTypes.string,
}

PasswordRequirementsHint.defaultProps = {
  value: "",
}

export default PasswordRequirementsHint
